import { jsx as _jsx } from "react/jsx-runtime";
import { useSearchClientsQuery } from '@massilia/queries';
import { AutoComplete, useDebounce } from '@massilia/ui';
import { Search } from 'lucide-react';
import { useMemo, useState } from 'react';
import { ClientCard } from '../components/client-card.js';
export function ClientSearchField({ onClientSelected, selectedClient }) {
    const [searchInput, setSearchInput] = useState('');
    const debouncedQuery = useDebounce(searchInput, 300);
    const { data: clients, isLoading } = useSearchClientsQuery(debouncedQuery);
    const options = useMemo(() => {
        if (!clients)
            return [];
        return clients.map((client) => ({
            label: `${client.firstName} ${client.lastName?.toUpperCase()} - ${client.email}`,
            value: client.id,
        }));
    }, [clients]);
    if (selectedClient) {
        return (_jsx(ClientCard, { client: selectedClient, mode: "editable", onDeselect: () => onClientSelected(null) }));
    }
    return (_jsx(AutoComplete, { emptyMessage: "Aucun client trouve", icon: _jsx(Search, { className: "h-4 w-4 text-gray-400" }), isLoading: isLoading, onInputChange: setSearchInput, onValueChange: (option) => {
            const client = clients?.find((c) => c.id === option.value);
            if (client) {
                onClientSelected(client);
            }
        }, options: options, placeholder: "Rechercher un client (nom, email, telephone)...", shouldFilter: false }));
}
